module.exports = __webpack_public_path__ + "img/title_logo.5c02a3e6.png";